(() => {
  const roots = [...document.querySelectorAll('[data-favourites]')];
  if (!roots.length) return;
  const endpoint = '/apps/archive-favourites';
  let items = [], token = '', pending = false;
  const buttons = () => [...document.querySelectorAll('[data-favourite-handle]')];
  const strings = roots[0].dataset;
  const status = message => roots.forEach(root => { const node=root.querySelector('[data-favourite-status]'); if(node)node.textContent=message; });
  function render() {
    buttons().forEach(button => {
      const saved=items.some(item=>item.handle===button.dataset.favouriteHandle);
      button.setAttribute('aria-pressed',String(saved));
      const label=saved?strings.saved:strings.save;
      button.querySelector('[data-favourite-label]').textContent=label;button.title=saved?strings.remove:strings.save;
      const card=button.closest('[data-card]');if(card)card.dataset.favouriteSaved=String(saved);
      button.disabled=pending;
    });
    document.querySelectorAll('[data-favourites-list]').forEach(list=>{
      list.replaceChildren();
      items.forEach(item=>{
        if(!/^[a-z0-9][a-z0-9-]{0,199}$/.test(item.handle))return;
        const row=document.createElement('li'),link=document.createElement('a'),remove=document.createElement('button');
        link.href='/pages/magazines/'+encodeURIComponent(item.handle);link.textContent=item.title;
        remove.type='button';remove.textContent=strings.remove;remove.setAttribute('aria-label',strings.remove+' — '+item.title);remove.disabled=pending;
        remove.addEventListener('click',()=>change(item,false));row.append(link,remove);list.append(row);
      });
    });
    document.querySelectorAll('[data-favourites-only]').forEach(input=>input.disabled=pending);
    document.dispatchEvent(new CustomEvent('archive:favourites-updated'));
    document.querySelectorAll('[data-favourites-empty]').forEach(node=>node.hidden=items.length!==0);
  }
  async function load() {
    pending=true;buttons().forEach(button=>button.disabled=true);status(strings.loading);
    try {
      const response=await fetch(endpoint,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error(response.status===401?'login':'error');
      const data=await response.json();
      if(!Array.isArray(data.items)||typeof data.token!=='string')throw new Error('error');
      items=data.items;token=data.token;pending=false;render();status('');
      document.querySelectorAll('[data-favourite-retry]').forEach(button=>button.hidden=true);
    } catch(error) {
      pending=false;status(error.message==='login'?strings.login:strings.error);
      document.querySelectorAll('[data-favourite-retry]').forEach(button=>button.hidden=false);
    }
  }
  async function change(article,save) {
    if(pending)return;pending=true;render();status(strings.saving);
    try {
      const response=await fetch(endpoint,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({token,action:save?'save':'remove',article})});
      const data=await response.json();
      if(!response.ok||data.ok!==true)throw new Error(data.error||'error');
      items=items.filter(item=>item.handle!==article.handle);if(save)items.unshift(article);
      pending=false;render();status(save?strings.added:strings.removed);
    } catch(error) {
      pending=false;render();status(error.message==='limit_reached'?strings.limit:strings.error);
      document.querySelectorAll('[data-favourite-retry]').forEach(button=>button.hidden=false);
    }
  }
  buttons().forEach(button=>button.addEventListener('click',()=>change({handle:button.dataset.favouriteHandle,title:button.dataset.favouriteTitle},button.getAttribute('aria-pressed')!=='true')));
  document.querySelectorAll('[data-favourite-retry]').forEach(button=>button.addEventListener('click',load));
  window.addEventListener('pageshow',event=>{if(event.persisted)load();});
  load();
})();
